import React, { type ComponentProps } from 'react';
import { StyleSheet, View } from 'react-native';

import { theme } from '@garnish/constants';
import { BodyText, DisplayText } from '@garnish/core';

// ─────────────────────────────────────────────────────────────────────────────

export const BundleCopy = (props: Props) => {
  const { name, description } = props;

  return (
    <View style={styles.container}>
      <DisplayText sizeMatch={NAME_SIZE_MATCH} style={styles.name} bold>
        {name}
      </DisplayText>

      <BodyText sizeMatch={DESCRIPTION_SIZE_MATCH} style={styles.description}>
        {description}
      </BodyText>
    </View>
  );
};

// ─── Constants ───────────────────────────────────────────────────────────────

const NAME_SIZE_MATCH: ComponentProps<typeof DisplayText>['sizeMatch'] = ['32'];
const DESCRIPTION_SIZE_MATCH: ComponentProps<typeof BodyText>['sizeMatch'] = ['16'];

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    gap: theme.spacing['1'],
    paddingTop: theme.spacing['4'],
    paddingHorizontal: theme.spacing['6'],
  },
  name: {
    color: theme.colors.KALE,
  },
  description: {
    color: theme.colors.CHARCOAL,
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = {
  name: string;
  description: string;
};
